/**
 * AI calls (`/ai-calls`): the section.
 *
 * Three pages behind one tab row: the results (every call the AI placed and what
 * came of it), the campaigns (whom it may ring, ring R3) and the automation
 * that rings them by itself (ring R4). Nested routes, so a campaign is a link
 * that can be pasted into a task.
 */
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { CampaignEditor } from "./campaigns/CampaignEditor";
import { CampaignsPage } from "./campaigns/CampaignsPage";
import { AutomationPage } from "./automation/AutomationPage";
import { AiCallResultsPage } from "./results/ResultsPage";

export function AiCallsSection({ user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route index element={<AiCallResultsPage user={user} />} />
      <Route path="campaigns" element={<CampaignsPage user={user} />} />
      {/* `new` is its own route: the static path outranks `:id`, so there is no id to compare. */}
      <Route path="campaigns/new" element={<CampaignEditor user={user} isNew />} />
      <Route path="campaigns/:id" element={<CampaignById user={user} />} />
      <Route path="automation" element={<AutomationPage user={user} />} />
      <Route path="*" element={<Navigate to="/ai-calls" replace />} />
    </Routes>
  );
}

/**
 * One campaign, keyed by its id: moving from one campaign straight to another
 * mounts a fresh editor instead of carrying the first one's draft across.
 */
function CampaignById({ user }: { user: StaffUser }) {
  const { id = "" } = useParams();
  return <CampaignEditor key={id} user={user} />;
}
